<template>
  <div>
    <!-- begin breadcrumb -->
    <ol class="breadcrumb float-xl-right">
      <li class="breadcrumb-item"><a :href="'/script'">Script</a></li>
      <li v-if="$route.params.type" class="breadcrumb-item">
        <a :href="'/script/' + $route.params.type">{{
          $route.params.type | capitalize
        }}</a>
      </li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      Script
      <small
        >Plan your production step by step. Input all pieces of space, stuff,
        staff and support service you need for a production of a specific step
        of your event.</small
      >
    </h1>
    <!-- end page-header -->
    <router-view
      v-bind:activeEvent="activeEvent"
      v-bind:storyboards="storyboards"
      v-bind:storyboard="storyboard"
      v-bind:stages="stages"
      v-bind:stage="stage"
      v-bind:steps="steps"
      v-bind:step="step"
      v-bind:categories="categories"
      v-bind:items="items"
      v-bind:scriptItems="scriptItems"
      v-bind:selectedSteps="selectedSteps"
      v-bind:createBankItemCall="createBankItemCall"
      v-bind:removeImage="removeImage"
      v-bind:removeFile="removeFile"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { imageService } from '../services/image.service.js'
import { fileService } from '../services/file.service.js'

export default {
  name: 'Script',
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  computed: {
    ...mapState('storyboard', ['storyboards', 'storyboard']),
    ...mapState('stage', ['stages', 'stage']),
    ...mapState('step', ['steps', 'step']),
    ...mapState('event', ['activeEvent']),
    ...mapState('item', ['items', 'item']),
    ...mapState('category', ['categories', 'category']),
    ...mapState('scriptitem', ['scriptItems', 'scriptItem'])
  },
  data() {
    return {
      selectedSteps: [],
      scriptItemsUpToDate: true,
      itemsUpToDate: true
    }
  },
  methods: {
    ...mapActions('storyboard', ['getStoryboards', 'getStoryboard']),
    ...mapActions('stage', ['getStages', 'getStage']),
    ...mapActions('step', ['getSteps', 'getStep', 'updateStep']),
    ...mapActions('item', ['getItems', 'getItem', 'createItem']),
    ...mapActions('category', ['getCategories', 'getCategory']),
    ...mapActions('scriptitem', [
      'getScriptItems',
      'getScriptItem',
      'createScriptItem',
      'updateScriptItem',
      'deleteScriptItem'
    ]),
    itemCreate(itemData) {
      this.createScriptItem(itemData)
      this.getScriptItems(this.activeEvent.id)
      this.scriptItemsUpToDate = false
    },
    itemUpdate(itemId, itemData) {
      this.updateScriptItem({ itemId, itemData })
      this.getScriptItems(this.activeEvent.id)
      this.scriptItemsUpToDate = false
    },
    itemDelete(itemId) {
      this.deleteScriptItem(itemId)
      this.getScriptItems(this.activeEvent.id)
      this.scriptItemsUpToDate = false
    },
    stepUpdate(stepId, stepData) {
      this.updateStep({ stepId, stepData })
      this.getSteps(this.activeEvent.id)
    },
    createNoteCall(noteData) {
      this.createNote(noteData)
    },
    submitNote(noteId, noteData) {
      this.updateNote({ noteId, noteData })
    },
    deleteNoteCall(noteId) {
      this.deleteNote(noteId)
    },
    createBankItemCall(itemData) {
      this.createItem(itemData)
      this.getItems(this.activeEvent.id)
      this.itemsUpToDate = false
    },
    removeImage(imageId) {
      imageService.deleteImage(imageId)
    },
    removeFile(fileId) {
      fileService.deleteFile(fileId)
    },
    filterSelectedSteps(selectedIds) {
      var filteredSteps = []
      this.steps.forEach((step) => {
        selectedIds.forEach((selectedStep) => {
          if (step.id == selectedStep.id) {
            filteredSteps.push(step)
          }
        })
      })
      this.selectedSteps = filteredSteps
      //
      let type = this.$route.params.type
      if (type) {
        this.$router.push(`/script/${type}`)
      } else {
        this.$router.push(`/script/space`)
      }
    },
    filterEventStages(event, sbFilterState = 'all') {
      var storyboards = this.filterEventStoryboards(event)
      var fStages = []
      storyboards.forEach((sb) => {
        var stages = this.stages.filter(function (stage) {
          return stage.storyboard == sb.id
        })
        stages.forEach((stage) => {
          if (!fStages.includes(stage) && stage.steps.length) {
            if (sbFilterState == 'all') {
              fStages.push(stage)
            } else {
              if (stage.storyboard == sbFilterState) {
                fStages.push(stage)
              }
            }
          }
        })
      })
      return fStages
    },
    filterEventStoryboards(event) {
      return this.storyboards.filter(function (sb) {
        return sb.event == event
      })
    },
    getStage(stageId) {
      var stage = this.stages.filter(function (stage) {
        return stage.id == stageId
      })
      return stage[0]
    },
    getStoryboard(stageId) {
      var storyboards = this.filterEventStoryboards(this.activeEvent.id)
      var stage = this.getStage(stageId)
      var storyboard = storyboards.filter(function (sb) {
        return sb.id == stage.storyboard
      })
      return storyboard[0]
    }
  },
  mounted() {
    this.getStoryboards(this.activeEvent.id)
    this.getStages(this.activeEvent.id)
    this.getSteps(this.activeEvent.id)
    this.getItems(this.activeEvent.id)
    this.getCategories(this.activeEvent.id)
    this.getScriptItems(this.activeEvent.id)
  },
  watch: {
    scriptItems: function () {
      if (!this.scriptItemsUpToDate) {
        this.getScriptItems(this.activeEvent.id)
        this.scriptItemsUpToDate = true
      }
    },
    items: function () {
      if (!this.itemsUpToDate) {
        this.getItems(this.activeEvent.id)
        this.itemsUpToDate = true
      }
    },
    steps: function () {
      // Go to step selected in event bank or dashboard
      if (this.$route.params.id) {
        let stepArray = []
        this.steps.forEach((step) => {
          if (step.id == this.$route.params.id) {
            stepArray.push(step)
          }
        })
        this.filterSelectedSteps(stepArray)
      }
    }
  }
}
</script>
